export default __webpack_public_path__ + "static/media/1915.fd5e3628.png";